import { FIND_SPEC_YEARS_REQUEST, findSpecYearsSuccess, findSpecYearsFailure } from 'Redux/Action';
import { ofType } from 'redux-observable';
import { from } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

export function findSpecYearsEpic(action$, store$, { ResultRepository }) {
    return action$.pipe(
        ofType( FIND_SPEC_YEARS_REQUEST ),
        mergeMap(action => from(
            ResultRepository.findAllSpecYears(action.payload)
                .then(( specYears ) => findSpecYearsSuccess({ specYears }))
                .catch(error => findSpecYearsFailure({ error, request: action })),
        )),
    );
}
